<script lang="ts">
  import { goto } from '$app/navigation';
  import Alert from '$lib/components/common/bootstrap/Alert.svelte';
  import Loading from '$lib/components/Loading.svelte';
  import BadgeGrid from '$lib/components/student/BadgeGrid.svelte';
  import type { OptInOutDirection, SkillLogContext } from '$lib/componentTypes';
  import type { PageProps } from './$types';
  import { getContext, tick } from 'svelte';
  import OptInOutConfirmModal from '$lib/components/student/OptInOutConfirmModal.svelte';

  let { data, params }: PageProps = $props();

  let { getIsPosting, getPostError, getUpdatedLeaderboard } = getContext<SkillLogContext>('skillLog');

  let isPosting = $derived(getIsPosting());
  let postError = $derived(getPostError());
  let updatedLeaderboard = $derived(getUpdatedLeaderboard());

  let optInOut: OptInOutDirection = $state(null);

  $effect(() => {
    if (!isPosting && updatedLeaderboard.loggedSkillCount === 0) {
      goto(`/classes/${params.id}`, { replaceState: true });
    }
  });
</script>

{#await data.classPromise}
  <Loading />
{:then leaderboard}
  {#if isPosting}
    <Loading />
  {:else if postError}
    <Alert color="danger">{postError}</Alert>
    <div class="d-grid my-5">
      <a href="/classes/{params.id}/log">Try again</a>
    </div>
  {:else}
    <div class="row">
      <div class="col col-12 col-md-8 col-lg-6 m-auto">
        <h2>Your skill{updatedLeaderboard.loggedSkillCount === 1 ? ' has' : 's have'} been logged</h2>
        {#if updatedLeaderboard.loggedSkillCount > 1}
          <p>
            {updatedLeaderboard.loggedSkillCount} skills
          </p>
        {/if}

        <BadgeGrid
          classId={leaderboard.classId}
          badgeProgress={leaderboard.badgeProgress.filter(x =>
            updatedLeaderboard.updatedCategoryIds.includes(x.skillCategoryId),
          )}
          courseSkillCategories={leaderboard.class.course.skillCategories}
          formerIncompleteSkillCategories={updatedLeaderboard.formerIncompleteBadgesOfUpdatedCategories}
        />

        <div class="row row-cols-2 my-4">
          <div class="col mx-auto">
            <h3 class="text-center subtle-header">Your score</h3>
            <div class="text-center fs-1 fw-bold">
              {leaderboard.score}
            </div>
          </div>
          {#if leaderboard.isOptedIn && updatedLeaderboard.userRank !== null}
            <div class="col mx-auto">
              <h3 class="text-center subtle-header">Rank</h3>
              <div class="text-center fs-1 fw-bold">
                &num;{updatedLeaderboard.userRank}
              </div>
            </div>
          {/if}
        </div>

        {#if !leaderboard.isOptedIn}
          <p>
            Compete with the rest of your class by <a
              href="/"
              onclick={e => {
                e.preventDefault();
                optInOut = 'in';
              }}>Opting into the class leaderboard</a
            >!
          </p>
        {/if}

        <div class="d-grid gap-3">
          <a class="btn btn-primary" href="/classes/{params.id}/leaderboard">View Leaderboard</a>
          <a class="btn btn-secondary" href="/classes/{params.id}/log">Log Another Skill</a>
        </div>
      </div>
    </div>
  {/if}

  {#if optInOut !== null}
    <OptInOutConfirmModal
      classId={leaderboard.classId}
      bind:optIn={optInOut}
      onClose={() => {
        tick().then(() => {
          goto(`/classes/${params.id}/leaderboard`, { replaceState: true });
        });
      }}
    />
  {/if}
{/await}
